module.exports = __webpack_public_path__ + "img/loading.2b737b6e.gif";